import React from "react";
import Bubbles from "./components/Bubbles";
import "./App.css";
import "../src/styles/table.css";

function App() {
  return (
    <div className="App">
      <Bubbles></Bubbles>
      </div>
  );
}

export default App;
